// ABOUTME: Status badge component for displaying provisioning status.
// ABOUTME: Shows colored badges with optional tooltips for error messages.

import { Tooltip } from '@/components/ui/Tooltip';
import type { ServicePrincipalStatus } from '@/types/admin';

interface StatusBadgeProps {
  status: ServicePrincipalStatus | 'pending';
  label?: string;
  errorMessage?: string | null;
}

export function StatusBadge({ status, label, errorMessage }: StatusBadgeProps) {
  const colors: Record<string, string> = {
    active: 'bg-success/10 text-success border-success/30',
    provisioning: 'bg-accent-500/10 text-accent-600 border-accent-500/30 animate-pulse',
    failed: 'bg-error/10 text-error border-error/30',
    pending: 'bg-surface-100 text-surface-500 border-surface-300',
    disabled: 'bg-surface-100 text-surface-500 border-surface-300',
  };

  const displayLabel = label || status.charAt(0).toUpperCase() + status.slice(1);

  const badge = (
    <span className={`px-2 py-1 rounded-sm text-xs border ${colors[status] || colors.pending}`}>
      {displayLabel}
    </span>
  );

  // Wrap with tooltip if there's an error message
  return errorMessage ? (
    <Tooltip content={errorMessage} className="max-w-xs">
      {badge}
    </Tooltip>
  ) : (
    badge
  );
}
